<!------------------------------------------------>
<!--            결제 정보 요약            -->
<!------------------------------------------------>
<template>
  <div :key="componentKey" v-if="done" class="payment-card">
    <div class="payment-card__inner">
      <div class="payment-card__header">
        <span class="payment-card__title">결제 정보</span>
      </div>
      <template v-if="isPromotion">
        <!-- 프로모션 요금제일 경우 -->
        <div class="payment-card__section">
          <div class="payment-card__label">적용된 프로모션 요금제</div>
          <div class="payment-card__value payment-card__value--primary">{{ paymentSummary.feeName }}</div>
        </div>
        <div class="payment-card__section">
          <div class="payment-card__label">요금 합계</div>
          <div class="payment-card__detail">
          </div>
        </div>
        <div class="payment-card__section payment-card__section--total">
          <div class="payment-card__label">총 금액(VAT 10% 포함)</div>
          <v-text-field
            class="payment-card__total-input editor_bg rounded right-input"
            :value="`${formatToKoreanWon(paymentSummary.paymentAmount)}원`"
            readonly
            solo
            placeholder="총 금액(VAT 10% 포함)"
          />
        </div>
      </template>
      <template v-else>
        <!-- 일반 요금제일 경우 -->
        <div class="payment-card__section">
          <div class="payment-card__label">적용된 요금제</div>
          <div class="payment-card__value">{{ `${paymentSummary.feeName} (월 ${formatToKoreanWon(paymentSummary.feeOriginAmount)}원)` }}</div>
        </div>
        <div class="payment-card__section">
          <div class="payment-card__label">결제일</div>
          <div class="payment-card__value">{{ `${paymentSummary.paymentDt.replaceAll('-', '.')}`}}</div>
        </div>
        <div class="payment-card__section">
          <div class="payment-card__label">결제 수단</div>
          <div class="payment-card__value">{{ `${paymentSummary.orderType === 'AC' ? '계좌이체' : '카드 결제'}` }}</div>
        </div>
        <div v-if="paymentSummary.discountMethod" class="payment-card__section payment-card__section--discount">
          <div class="payment-card__label">적용된 할인</div>
          <div v-if="paymentSummary.discountMethod === '00001'" class="payment-card__value">
            {{ `${paymentSummary.discountName} (월 요금 ${formatToKoreanWon(paymentSummary.discountAmount)}원 할인)` }}
          </div>
          <div v-if="paymentSummary.discountMethod === '00002'" class="payment-card__value">
            {{ `${paymentSummary.discountName} (월 요금 ${paymentSummary.discountPercent}% 할인)` }}
          </div>
        </div>
        <template v-if="type === 'PAY'">
          <div class="payment-card__section payment-card__section--total">
            <div class="payment-card__label">총 금액(VAT 10% 포함)</div>
            <v-text-field
              class="payment-card__total-input editor_bg rounded right-input"
              :value="`${formatToKoreanWon(paymentSummary.paymentAmount)}원`"
              readonly
              solo
              placeholder="총 금액(VAT 10% 포함)"
            />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
// 컴포넌트
import baseview from '@/views/base/baseview.vue'
// api
import { getSojunganFeePaymentInfo } from '@/payment/api/sojunganFeeInfo.js'
import { getDiscountListByFee } from '@/api/feeManage/discountManage.js'
import { getPaymentSummary } from '@/api/sojunganManagement/constructManage.js'
// utils
// import { getDateDiff } from '@/utils/common.js'
import { getCommonCode } from '@/api/common/commonApi'
//
export default {
  mixins: [baseview],
  components: {},
  name: 'paymentSummary',
  props: {
    uniqueKey: {
      type: String,
      default: () => '', // 랜더링 키값
    },
    type: {
      type: String,
      default: () => 'PAY', // 금액 산출 기준 (PAY,CANCEL)
    },
    startDate: {
      type: String,
      default: () => '', // 사용기간 측정 기준이 되는 시작일
    },
    endDate: {
      type: String,
      default: () => '', // 사용기간 측정 기준이 되는 종료일
    },
    feeCd: {
      type: String,
      default: () => '', // 요금제 코드
    },
    isPromotion: {
      type: Boolean,
      default: () => false, // 프로모션 요금제 플래그값
    },
    propsData: {
      type: Object,
      default: () => {}, // 키 값
    },
  },
  data() {
    return {
      componentKey: 0,
      calcData: {},
      done: false,
      discountList: [],
      totalDiscountAmount: 0,
      totalDiscountPercent: 0,
      paymentSummary: {},
    }
  },
  watch: {
    uniqueKey: {
      immediate: true,
      handler(orderId) {
        if (orderId) {
          this.btnSearch()
        }
      },
    },
  },
  activated() {},
  created() {},
  mounted() {},
  methods: {
    formatToKoreanWon(value) {
      if (value !== undefined && value !== null && value !== '') {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      }
      return '0'
    },
    btnSearch() {
      console.log('#### call canclePaymentSummary', this.propsData)
      this.done = false
      this.calcData = {}

      let param = {
        orderId: this.propsData.orderId,
        clntId: this.propsData.clntId,
        compId: this.propsData.compId,
      }
      
      getPaymentSummary(param, true).then((res) => {
        console.log('## 결제 정보 :: ', res)
        this.paymentSummary = res
        this.done = true
      })
    },
  },
}
</script>
<style scoped>
.payment-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

.payment-card__inner {
  padding: 0;
}

.payment-card__header {
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  color: #fff;
}

.payment-card__title {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.payment-card__section {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.payment-card__section:last-child {
  border-bottom: none;
}

.payment-card__section--total {
  background: #f8fafc;
  padding: 18px 20px;
}

.payment-card__section--discount {
  background: #fefdf8;
}

.payment-card__section--breakdown {
  background: #fafbfc;
}

.payment-card__label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.payment-card__value {
  font-size: 0.9375rem;
  color: #1e293b;
  line-height: 1.5;
}

.payment-card__value--primary {
  font-weight: 600;
  color: #0f172a;
}

.payment-card__detail {
  margin-top: 4px;
}

.payment-card__row {
  padding: 6px 0;
  font-size: 0.875rem;
  color: #334155;
  line-height: 1.5;
}

.payment-card__row--sub {
  padding-top: 10px;
  margin-top: 4px;
  border-top: 1px dashed #e2e8f0;
}

.payment-card__row-label {
  margin-right: 10px;
  color: #64748b;
}

.payment-card__row-value {
  color: #1e293b;
  font-weight: 500;
}

.payment-card__row-value--em {
  font-weight: 700;
  color: #0f172a;
}

.payment-card__row-op {
  margin: 0 6px;
  color: #94a3b8;
  font-weight: 500;
}

.payment-card__total-input >>> .v-input__slot {
  background: #fff !important;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.payment-card__total-input >>> input {
  text-align: right;
  font-size: 1.125rem !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.right-input >>> input {
  text-align: right;
}
</style>
